import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

import { StyledCard, StyledCardContent } from './OrderConversionChartPeriodRatio.styled';

export const OrderConversionChartPeriodRatioSkeleton: React.FC = () => (
  <StyledCard>
    <Box sx={{ padding: '14px 16px' }}>
      <Skeleton height={24} variant="text" width="60%" />
    </Box>
    <StyledCardContent>
      <Skeleton height="100%" variant="rectangular" width="100%" />
    </StyledCardContent>
  </StyledCard>
);
